import React from "react";

function WhatisMargin() {
  return (
    <>
      <div className="container p-5">
        <div
          className="pricing-style-one-item-cos bg-dark text-light"
          style={{
            backgroundImage:
              "url(https://validthemes.net/site-template/robok/assets/img/shape/10.png)",
          }}
        >
          <div className="text-center">
            <h3>What is Margin Trading Exchange?</h3>
            <div className="bottom">
              <div className="pricing">
                <p>
                  A Margin Trading Exchange is a platform that allows users to
                  borrow funds to trade assets with more capital than they
                  currently own. This practice of margin trading, lets traders
                  open larger positions by using leverage, which increases both
                  potential gains and losses. The additional capital is
                  typically provided by the exchange.
                </p>
              </div>
              <a className="btn btn-style-one mt-30" href="#">
                Get Started
              </a>
            </div>
          </div>
          {/* <div className="right-info"></div> */}
        </div>
      </div>
    </>
  );
}

export default WhatisMargin;
